const style = {
  uploadNotes: {
    fontSize: 13,
  },
  recordingActions: {
    width: 104
  },
  stopBtn: {
    background: "#F07939",
    '&:hover': {
      background: "#F07939",
    }
  },
};

export default style;